import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { LANDING_URL } from '../common/utils/url';

/**
 * Sends the user to the app home. `navigate` stays inside the Angular router.
 * `hardRedirect` reloads the page, for flows that must pick up a new session.
 */
@Injectable({
  providedIn: 'root',
})
export class HomeNavigationService {
  constructor(private readonly router: Router) {}

  navigate(queryParams?: Record<string, string>): Promise<boolean> {
    return this.router.navigate([`/${LANDING_URL}`], queryParams ? { queryParams } : {});
  }

  /** For guards that must return a UrlTree instead of navigating. */
  getHomeUrlTree(): UrlTree {
    return this.router.parseUrl(`/${LANDING_URL}`);
  }

  hardRedirect(queryParams?: Record<string, string>): void {
    window.location.href = `/${LANDING_URL}${this.buildQueryString(queryParams)}`;
  }

  private buildQueryString(queryParams?: Record<string, string>): string {
    const qs = new URLSearchParams(queryParams ?? {}).toString();
    return qs ? `?${qs}` : '';
  }
}
